import React, {Component} from "react";
import CreditCardInput from 'react-credit-card-input';

import axios from "axios";
import AuthService from "../../AuthService";
import loader from "../../img/loader.gif";


class BankForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formData: this.props.formData,
            villeId: this.props.villeId,
            cardNumber: '',
            expiry: '',
            cvc: '',
            paymentSuccess: true
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async componentDidMount() {
    }

    componentWillUnmount() {
    }

    handleCardNumberChange = (e) => {
        this.setState({cardNumber: e.target.value});
    }

    handleCardExpiryChange = (e) => {
        this.setState({expiry: e.target.value});
    }

    handleCardCVCChange = (e) => {
        this.setState({cvc: e.target.value});
    }

    async handleSubmit(event) {
        /*event.preventDefault();*/
        this.setState({loading: true});
        let options = [];
        this.state.formData.options.forEach((opt, index) => {
            let option = {id: index, nbCharged: opt};
            options.push(option);
        });

        let paymentObject = {};
        paymentObject.prix = this.state.formData.totalPrix;
        paymentObject.cardNumber = this.state.cardNumber.replace(/ /g, '');
        paymentObject.expiry = this.state.expiry.replace(' / ', '');
        paymentObject.cvc = this.state.cvc;

        await axios.post(AuthService.getUrl("/reservation"), {
            croisiere: this.state.formData.croisiere,
            paymentObject: paymentObject,
            villeId: this.state.villeId,
            options: options,
            withBank: true
        }, AuthService.getAuthHeader(this.state.locale)).then(res => {
            this.setState({loading: false});
            const codeResponse = res.data.data.bankResponse.codeReponse;
            /*PAYMENT SUCCESSFUL*/
            if (codeResponse === '00000') {
                this.setState({paymentSuccess: true});
                this.props.success(codeResponse);
            }
            /*PAYMENT FAILED*/
            else {
                this.setState({paymentSuccess: false});
            }
        });
    }

    render() {
        return (
            <div id="PaymentForm">
                <CreditCardInput
                    cardNumberInputProps={{value: this.state.cardNumber, onChange: e => this.handleCardNumberChange(e)}}
                    cardExpiryInputProps={{value: this.state.expiry, onChange: e => this.handleCardExpiryChange(e)}}
                    cardCVCInputProps={{value: this.state.cvc, onChange: e => this.handleCardCVCChange(e)}}
                    fieldClassName="input"
                />
                <button type="button" className="validButton" style={{"width": "calc(100%)", "fontSize": "15px"}}
                        onClick={() => this.handleSubmit()}>{"Valider"}</button>
                {!this.state.paymentSuccess &&
                    <div>
                        <span className="validButton"
                              style={{"width": "calc(100% - 60px)", "fontSize": "15px", "background-color": "#b71c1c", "margin-top": "10px"}}
                              type="submit">{"Paiement refusé"}</span>
                    </div>
                }
                {this.state.loading &&
                    <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
                }
            </div>
        );
    }
}

export default BankForm;
